import { todoService } from '../_services';

const getDefaultState = () => {
  return {
    all: {},
    current: {},
    myTodos: {},
    loading: false
  }
}

export const todos = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },
    getAllTodos({ commit }) {
      commit('getAllTodosRequest');
      todoService.getAll()
      .then(
          todos => commit('getAllTodosSuccess', todos),
          error => commit('getAllTodosFailure', error)
      );
    },
    searchTodos({ commit }, qry) {
      commit('getAllTodosRequest');
      todoService.searchtodos(qry)
      .then(
          todos => commit('getAllTodosSuccess', todos),
          error => commit('getAlltodosFailure', error)
      );
    },
    getById({ commit }, id) {
      commit('getByIdRequest');
      todoService.getById(id)
      .then(
        response => {
          commit('getByIdSuccess', response);
          return response;
        },
          error => {
            commit('getByIdFailure', error)
          return error;
          }
      );
    },
    addTodo({ commit }, payload){
      commit('addTodoRequest');
      todoService.addTodo(payload)
      .then(
        todos => commit('addTodoSuccess', todos),
        error => commit('addTodoFailure', error)
      )
    },
    updateTodo({ commit }, payload){
      commit('addTodoRequest');
      todoService.updateTodo(payload)
      .then(
        todos => commit('addTodoSuccess', todos),
        error => commit('addTodoFailure', error)
      )
    },
    deleteTodo({ commit }, payload){
      commit('deleteTodoRequest');
      todoService.deleteTodo(payload)
      .then(
        commit('deleteTodoSuccess'),
        error => commit('deleteTodoFailure', error)
      )
      return true;
    }
  },
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    getAllTodosRequest(state) {
      state.loading = 'loading';
    },
    getAllTodosSuccess(state, todos) {
      state.loading = false;
      state.myTodos = Object.values(todos);
      return true;
    },
    getAllTodosFailure(state, error) {
      state.loading = false;
      state.myTodos = { error };
      return error;
    },
    getByIdRequest(state) {
      state.current = { loading: true };
    },
    getByIdSuccess(state, todo) {
      state.current = todo;
      return todo;
    },
    getByIdFailure(state, error) {
        state.current = { error };
        return error;
    },
    addTodoRequest(state, todo) {
      state.current = todo
    },
    addTodoSuccess(state, todo) {
      state.current = todo;
      return true;
    },
    addTodoFailure(state, error) {
      state.update = { error };
      return error;
    },
    deleteTodoRequest(state, todo) {
      state.current = todo
    },
    deleteTodoSuccess(state) {
        state.current = {};
        return true;
    },
    deleteTodoFailure(state, error) {
      state.update = { error };
    }
  }
}